import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WidgetCronogramaComponent } from './widget-cronograma/widget-cronograma.component';
import { TemplateImportComponent } from './template-import/template-import.component';
import { ComponentsModule } from '../components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    MatTooltipModule,
    ComponentsModule,
  ],
  declarations: [
    WidgetCronogramaComponent,
    TemplateImportComponent,
  ],
  exports: [
    WidgetCronogramaComponent,
    TemplateImportComponent,
  ]
})
export class ModalsModule { }
